export enum StoryOpStatus {
  Pending = "pending",
  PendingMux = "pending_mux",
  PendingSpeechmatics = "pending_speechmatics",
  Completed = "completed",
  Failed = "failed",
  NoOp = "no_op",
}

export enum StoryOpErrorDataMsg {
  MuxTimeout = "pending_mux_timeout",
  SpeechmaticsFailure = "speechmatics_failure",
  NoAudioTrack = "no_audio_track",
}

export const storyOpDefaultFailureMessages: Record<StoryOpErrorDataMsg, string> = {
  [StoryOpErrorDataMsg.MuxTimeout]: "We couldn't finish processing your upload. Use Retry Transcription to try again.",
  [StoryOpErrorDataMsg.SpeechmaticsFailure]:
    "We couldn't complete the transcription. Please try regenerating the transcript.",
  [StoryOpErrorDataMsg.NoAudioTrack]: "This video doesn't have an audio track, so a transcript can't be generated.",
};

const pendingStatuses = new Set<StoryOpStatus>([
  StoryOpStatus.Pending,
  StoryOpStatus.PendingMux,
  StoryOpStatus.PendingSpeechmatics,
]);

export const isStoryOpPending = (status: StoryOpStatus | undefined | null) => !!status && pendingStatuses.has(status);
